import styled from 'styled-components';
import { Spacing16 } from 'autogen/design-tokens/tokens';
import type { ISignupNudgingCardWithFooter } from './SignupNudgingCard';
import SignupLoginOptions from './components/SignupLoginOptions';
import SignupNudgingCardRenderer from './components/SignupNudgingCardRenderer';
import ImageCard from 'components/ImageCard';
import { breakpoint } from 'variables';
import { getColors } from './shared/styles';
import type { SignupNudgingType } from 'autogen/swagger/all';

/* #region  styles */
const RootContainer = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: ${Spacing16};
`;

const StyledSignupNudgingCardRenderer = styled(SignupNudgingCardRenderer)<{ $type: SignupNudgingType }>`
    ${({ $type }) => getColors($type)}

    border: 1px solid var(--color-4);

    ${breakpoint.up('768px')} {
        border: 0;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
`;
/* #endregion */

export default function SignupNudgingCardWithImage({
    model,
    size = { xs: 'sm', sm: 'md' },
    displayLoginOptions
}: ISignupNudgingCardWithFooter) {
    return (
        <RootContainer>
            <ImageCard
                image={model.banner}
                cardRenderer={() => <StyledSignupNudgingCardRenderer model={model} size={size} $type={model.type} />}
            />
            {model.footer && displayLoginOptions && <SignupLoginOptions model={model} />}
        </RootContainer>
    );
}
